(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.querySelector('.cart-drawer');
    if (!drawer) return;

    var trigger = document.querySelector('.header__cart');

    /* Dot leaders: fill each with the exact whole-dot count for its gap. */
    function fillLeader(leader) {
      leader.style.letterSpacing = '0';
      leader.textContent = '';
      var probe = document.createElement('span');
      probe.textContent = '..................................................';
      probe.style.whiteSpace = 'pre';
      leader.appendChild(probe);
      var dotWidth = probe.getBoundingClientRect().width / 50;
      leader.removeChild(probe);
      var width = leader.getBoundingClientRect().width;
      if (dotWidth <= 0 || width <= 0) return;
      var count = Math.round(width / dotWidth);
      if (count < 1) return;
      leader.style.letterSpacing = (width / count - dotWidth) + 'px';
      leader.textContent = '.'.repeat(count);
    }
    function fillLeaders() {
      var leaders = drawer.querySelectorAll('.cart-leader');
      for (var i = 0; i < leaders.length; i++) fillLeader(leaders[i]);
    }

    function open() {
      drawer.inert = false;
      drawer.classList.add('cart-drawer--open');
      document.documentElement.style.overflow = 'hidden';
      fillLeaders();
    }
    function close() {
      drawer.classList.remove('cart-drawer--open');
      drawer.inert = true;
      document.documentElement.style.overflow = '';
    }

    /* Re-render the drawer contents from the server after any cart change. */
    function refresh() {
      fetch('/?sections=cart-drawer')
        .then(function (response) { return response.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('.cart-drawer__contents');
          var live = drawer.querySelector('.cart-drawer__contents');
          if (fresh && live) {
            live.innerHTML = fresh.innerHTML;
            fillLeaders();
          }
        })
        .catch(function () {});
    }

    function removeItem(key) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: cart.item_count } }));
        })
        .catch(function () {});
    }

    if (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        open();
      });
    }

    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-close]')) { close(); return; }
      var remove = event.target.closest('[data-cart-remove]');
      if (remove) removeItem(remove.getAttribute('data-cart-remove'));
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('cart-drawer--open')) close();
    });

    /* Any cart change: update the title count and re-render the contents. */
    document.addEventListener('cart:updated', function (event) {
      var count = event.detail && event.detail.count;
      var countEl = drawer.querySelector('.cart-drawer__count');
      if (countEl && count != null) countEl.textContent = count;
      refresh();
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fillLeaders, 150);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fillLeaders);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-banner"]) return;
  try {
    
  (function () {
    var banner = document.querySelector('.cookie-banner');
    if (!banner) return;

    function hideBanner() {
      /* Slide down off-screen (cart easing), then drop it from the layout. */
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        banner.hidden = true;
        return;
      }
      banner.classList.add('cookie-banner--closing');
      var removed = false;
      function remove() {
        if (removed) return;
        removed = true;
        banner.hidden = true;
      }
      banner.addEventListener('transitionend', function (event) {
        if (event.propertyName === 'transform') remove();
      });
      setTimeout(remove, 600); /* fallback if transitionend doesn't fire */
    }

    function recordConsent(accepted) {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api) return;
      api.setTrackingConsent(
        { analytics: accepted, marketing: accepted, preferences: accepted },
        hideBanner
      );
    }

    banner.addEventListener('click', function (event) {
      var button = event.target.closest('[data-consent]');
      if (!button) return;
      recordConsent(button.getAttribute('data-consent') === 'accept');
    });

    function maybeShow() {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      // shouldShowBanner() only checks the region — it does NOT know whether the
      // visitor has already chosen. So also confirm consent is still undeclared.
      if (!api || !api.shouldShowBanner()) return;
      var consent = api.currentVisitorConsent();
      var undeclared = !consent || Object.values(consent).every(function (value) {
        return value === '';
      });
      if (undeclared) banner.hidden = false;
    }

    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (!error) maybeShow();
        }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* Footer links: on hover/focus the letters scroll one by one and wrap around,
     clipped to a fixed window so the width never changes. The stray space keeps
     the cycle a constant length; the first step fires immediately. */
  (function () {
    /* No reliable hover on touch (a tap can start the effect without a clean
       exit), so bypass these on mobile / no-hover devices. */
    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      window.matchMedia('(hover: none)').matches ||
      window.matchMedia('(max-width: 768px)').matches
    ) {
      return;
    }

    function scroller(link, base) {
      if (!link) return;
      var el = link.querySelector('[data-scroll]');
      if (!el) return;
      var current = base;
      var timer = null;
      el.textContent = base;
      function step() {
        current = current.slice(1) + current.charAt(0);
        el.textContent = current;
      }
      function start() {
        clearInterval(timer);
        step();
        timer = setInterval(step, 150);
      }
      function stop() {
        clearInterval(timer);
        current = base;
        el.textContent = base;
      }
      link.addEventListener('mouseenter', start);
      link.addEventListener('mouseleave', stop);
      link.addEventListener('focus', start);
      link.addEventListener('blur', stop);
    }

    scroller(document.querySelector('.footer__copyright'), '© WEEKEND ');
    scroller(document.querySelector('.footer__email'), 'HELLO@WEEKENDWEEKEND.COM ');
    scroller(document.querySelector('.footer__privacy'), 'PRIVACY POLICY ');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    /* Keep the cart count in sync when items are added or removed. */
    document.addEventListener('cart:updated', function (event) {
      var countEl = document.querySelector('.header__cart-count');
      if (countEl) countEl.textContent = (event.detail && event.detail.count) || 0;
    });
  })();

  (function () {
    /* Wordmark hover: type out " is the time for play", backspace on leave. */
    var wordmark = document.querySelector('.header__wordmark');
    if (!wordmark) return;
    var typed = wordmark.querySelector('.header__wordmark-typed');
    if (!typed) return;

    /* Touch devices have no reliable hover — a tap can start the effect without a
       clean exit and leave it stuck — so bypass it on mobile / no-hover devices. */
    if (
      window.matchMedia('(hover: none)').matches ||
      window.matchMedia('(max-width: 768px)').matches
    ) {
      return;
    }

    var suffix = ' is the time for play';
    var typeSpeed = 50; /* ms per character while typing */
    var backSpeed = 25; /* ms per character while backspacing (faster) */
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;

    function run(forward) {
      if (timer) { clearInterval(timer); timer = null; }
      if (reduce) {
        typed.textContent = forward ? suffix : '';
        return;
      }
      timer = setInterval(function () {
        var len = typed.textContent.length;
        if (forward ? len >= suffix.length : len <= 0) {
          clearInterval(timer);
          timer = null;
          return;
        }
        typed.textContent = suffix.slice(0, forward ? len + 1 : len - 1);
      }, forward ? typeSpeed : backSpeed);
    }

    wordmark.addEventListener('mouseenter', function () { run(true); });
    wordmark.addEventListener('mouseleave', function () { run(false); });
  })();

  (function () {
    /* PLUGINS hover: one letter goes invisible at a time, the gap travelling
       through the word and wrapping around. Width is unchanged (the letter
       becomes a space). */
    var link = document.querySelector('.header__plugins');
    if (!link) return;
    var el = link.querySelector('.header__plugins-text');
    if (!el) return;
    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      window.matchMedia('(hover: none)').matches ||
      window.matchMedia('(max-width: 768px)').matches
    ) {
      return;
    }

    var base = 'PLUGINS';
    var i = 0;
    var timer = null;

    function step() {
      el.textContent = base.slice(0, i) + ' ' + base.slice(i + 1);
      i = (i + 1) % base.length;
    }
    function start() {
      clearInterval(timer);
      i = 0;
      step();
      timer = setInterval(step, 150);
    }
    function stop() {
      clearInterval(timer);
      el.textContent = base;
    }

    link.addEventListener('mouseenter', start);
    link.addEventListener('mouseleave', stop);
    link.addEventListener('focus', start);
    link.addEventListener('blur', stop);
  })();

  (function () {
    /* BAG hover: the brackets around the count rotate through styles. */
    var link = document.querySelector('.header__cart');
    if (!link) return;
    var open = link.querySelector('[data-bracket-open]');
    var close = link.querySelector('[data-bracket-close]');
    if (!open || !close) return;
    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      window.matchMedia('(hover: none)').matches ||
      window.matchMedia('(max-width: 768px)').matches
    ) {
      return;
    }

    var pairs = [['(', ')'], ['[', ']'], ['{', '}'], ['<', '>'], ['|', '|']];
    var i = 0;
    var timer = null;

    function show() {
      open.textContent = pairs[i][0];
      close.textContent = pairs[i][1];
    }
    function step() {
      i = (i + 1) % pairs.length;
      show();
    }
    function start() {
      clearInterval(timer);
      step();
      timer = setInterval(step, 150);
    }
    function stop() {
      clearInterval(timer);
      i = 0;
      show();
    }

    link.addEventListener('mouseenter', start);
    link.addEventListener('mouseleave', stop);
    link.addEventListener('focus', start);
    link.addEventListener('blur', stop);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var form = document.querySelector('.product__form');
    if (!form) return;
    var button = form.querySelector('.product__add');
    var productId = form.getAttribute('data-product-id');

    function openDrawer() {
      var trigger = document.querySelector('.header__cart');
      if (trigger) trigger.click();
    }

    /* Decode/scramble transition: on click the label scrambles while the add
       request is in flight, then resolves into "IN BAG" when it completes. */
    var scrambleEl = button.querySelector('[data-scramble]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var CHARS = 'ADTOBGIN'; /* the letters that make up "ADD TO BAG" and "IN BAG" */
    var loadTimer = null;
    var resolveTimer = null;

    function randChar() {
      return CHARS.charAt(Math.floor(Math.random() * CHARS.length));
    }
    function scrambleText() {
      var s = '';
      for (var i = 0; i < 10; i++) s += randChar();
      return s;
    }
    function startScramble() {
      form.classList.add('product__form--processing');
      scrambleEl.textContent = scrambleText();
      clearInterval(loadTimer);
      loadTimer = setInterval(function () {
        scrambleEl.textContent = scrambleText();
      }, 50);
    }
    function resolveScramble(done) {
      clearInterval(loadTimer);
      var target = '    IN BAG'; // leading spaces keep "IN BAG" settling on the right
      var frame = 0;
      var total = 9;
      clearInterval(resolveTimer);
      resolveTimer = setInterval(function () {
        /* Resolve as a contiguous left-to-right front: the first `resolved`
           characters lock to the target, the rest scramble. This makes the
           scramble block shrink cleanly inward toward "IN BAG" with no stray
           detached letters. */
        var resolved = Math.round((frame / total) * target.length);
        var out = '';
        for (var j = 0; j < target.length; j++) {
          out += j < resolved ? target.charAt(j) : randChar();
        }
        scrambleEl.textContent = out;
        frame += 1;
        if (frame > total) {
          clearInterval(resolveTimer);
          scrambleEl.textContent = target;
          done();
        }
      }, 50);
    }
    function endScramble() {
      clearInterval(loadTimer);
      clearInterval(resolveTimer);
      form.classList.remove('product__form--processing');
    }

    function addToCart(onSuccess) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return fetch('/cart.js');
        })
        .then(function (response) { return response.json(); })
        .then(function (cart) { onSuccess(cart); })
        .catch(function () { endScramble(); form.submit(); });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      /* If the product is already in the bag, this button opens the bag drawer
         instead of adding again. */
      if (form.classList.contains('product__form--in-cart')) {
        openDrawer();
        return;
      }

      function settle(cart) {
        form.classList.add('product__form--in-cart');
        endScramble();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: cart.item_count } }));
      }

      if (reduceMotion) {
        addToCart(settle);
        return;
      }

      startScramble();
      var startedAt = Date.now();
      addToCart(function (cart) {
        /* Keep the scramble up for a minimum time so a fast request still reads. */
        var wait = Math.max(0, 250 - (Date.now() - startedAt));
        setTimeout(function () {
          resolveScramble(function () { settle(cart); });
        }, wait);
      });
    });

    /* When the cart changes anywhere (e.g. an item removed in the drawer),
       re-sync this button: revert to "Add to bag" if the product is no longer
       in the cart, so it can be added again. */
    document.addEventListener('cart:updated', function () {
      fetch('/cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var inCart = cart.items.some(function (item) {
            return String(item.product_id) === String(productId);
          });
          form.classList.toggle('product__form--in-cart', inCart);
        })
        .catch(function () {});
    });
  })();

  // Fill each spec's dot leader with the exact number of whole dots for its gap.
  (function () {
    var leaders = document.querySelectorAll('.spec__leader');
    if (!leaders.length) return;

    function fill(leader) {
      leader.style.letterSpacing = '0';
      leader.textContent = '';
      var probe = document.createElement('span');
      probe.textContent = '..................................................';
      probe.style.whiteSpace = 'pre';
      leader.appendChild(probe);
      var dotWidth = probe.getBoundingClientRect().width / 50;
      leader.removeChild(probe);
      var width = leader.getBoundingClientRect().width;
      if (dotWidth <= 0 || width <= 0) return;
      var count = Math.round(width / dotWidth);
      if (count < 1) return;
      leader.style.letterSpacing = (width / count - dotWidth) + 'px';
      leader.textContent = '.'.repeat(count);
    }

    function fillAll() {
      for (var i = 0; i < leaders.length; i++) fill(leaders[i]);
    }

    fillAll();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fillAll, 150);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fillAll);
    }
  })();

  /* Product video: custom PLAY/PAUSE, a draggable dot-leader scrubber with a
     time readout, and a full-screen toggle. */
  (function () {
    var media = document.querySelector('.product__media--has-video');
    if (!media) return;
    var video = media.querySelector('[data-product-video]');
    var image = media.querySelector('.product__image');
    var toggle = media.querySelector('[data-video-toggle]');
    var fsBtn = media.querySelector('[data-video-fs]');
    var scrub = media.querySelector('[data-video-scrub]');
    if (!video || !scrub) return;

    var scrubCount = 0;
    var dragging = false;

    function fmt(t) {
      t = isFinite(t) ? Math.max(0, Math.floor(t)) : 0;
      var m = Math.floor(t / 60);
      var s = t % 60;
      return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    function dots(n) {
      return n > 0 ? new Array(n + 1).join('.') : '';
    }

    /* Fill the scrubber with the exact whole-dot count for its width, flush both
       ends (same technique as the spec dot leaders). */
    function measure() {
      scrub.style.letterSpacing = '0';
      var probe = document.createElement('span');
      probe.textContent = '..................................................';
      probe.style.whiteSpace = 'pre';
      scrub.textContent = '';
      scrub.appendChild(probe);
      var dotWidth = probe.getBoundingClientRect().width / 50;
      scrub.removeChild(probe);
      var width = scrub.getBoundingClientRect().width;
      if (dotWidth <= 0 || width <= 0) { scrubCount = 0; return; }
      var count = Math.round(width / dotWidth);
      if (count < 5) count = 5;
      scrub.style.letterSpacing = (width / count - dotWidth) + 'px';
      scrubCount = count;
      render();
    }

    /* Draw the leader with the time readout centred on the play position. */
    function render(forceFrac) {
      if (!scrubCount) return;
      var dur = video.duration || 0;
      var frac = forceFrac != null ? forceFrac : (dur ? video.currentTime / dur : 0);
      var time = fmt(forceFrac != null ? forceFrac * dur : video.currentTime);
      var n = scrubCount;
      var len = time.length;
      var i = Math.round(frac * (n - 1));
      var start = i - Math.floor(len / 2);
      if (start < 0) start = 0;
      if (start > n - len) start = n - len;
      scrub.textContent = dots(start) + time + dots(n - start - len);
    }

    function activate() {
      if (media.classList.contains('product__media--active')) return;
      media.classList.add('product__media--active');
      requestAnimationFrame(measure);
    }

    function start() {
      media.classList.add('product__media--loading');
      video.play();
    }
    if (image) image.addEventListener('click', start);
    var playBtn = media.querySelector('[data-video-play]');
    if (playBtn) playBtn.addEventListener('click', start);

    toggle.addEventListener('click', function () {
      if (video.paused) video.play(); else video.pause();
    });

    /* Clicking anywhere on the video toggles play/pause. Clicks on the controls
       hit those elements (not the video), so they're unaffected. */
    video.addEventListener('click', function () {
      if (video.paused) video.play(); else video.pause();
    });

    /* Reveal the video only once it's genuinely playing (frames rolling), so the
       poster stays put during buffering instead of showing a frozen first frame. */
    video.addEventListener('playing', function () {
      media.classList.remove('product__media--loading');
      media.classList.remove('product__media--paused');
      activate();
    });
    video.addEventListener('pause', function () {
      media.classList.add('product__media--paused');
    });
    /* When the video ends, return to the original state: hide the video and
       show the image again with the PLAY VIDEO cursor, ready to replay. */
    video.addEventListener('ended', function () {
      media.classList.remove('product__media--active');
      media.classList.remove('product__media--paused');
      video.currentTime = 0;
    });
    video.addEventListener('loadedmetadata', function () {
      if (media.classList.contains('product__media--active')) measure();
    });
    video.addEventListener('timeupdate', function () {
      if (!dragging) render();
    });

    fsBtn.addEventListener('click', function () {
      if (document.fullscreenElement || document.webkitFullscreenElement) {
        (document.exitFullscreen || document.webkitExitFullscreen).call(document);
      } else if (media.requestFullscreen) {
        media.requestFullscreen();
      } else if (media.webkitRequestFullscreen) {
        media.webkitRequestFullscreen();
      } else if (video.webkitEnterFullscreen) {
        video.webkitEnterFullscreen();
      }
    });

    /* Reflect fullscreen state (FS <-> EXIT) and re-measure the leader for the
       new frame size. */
    function onFullscreenChange() {
      var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      media.classList.toggle('product__media--fullscreen', fsEl === media);
      if (media.classList.contains('product__media--active')) requestAnimationFrame(measure);
    }
    document.addEventListener('fullscreenchange', onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', onFullscreenChange);

    function seek(event) {
      var rect = scrub.getBoundingClientRect();
      var frac = rect.width ? (event.clientX - rect.left) / rect.width : 0;
      frac = Math.max(0, Math.min(1, frac));
      if (video.duration) video.currentTime = frac * video.duration;
      render(frac);
    }
    scrub.addEventListener('pointerdown', function (event) {
      dragging = true;
      if (scrub.setPointerCapture) {
        try { scrub.setPointerCapture(event.pointerId); } catch (err) {}
      }
      seek(event);
      event.preventDefault();
    });
    scrub.addEventListener('pointermove', function (event) {
      if (dragging) seek(event);
    });
    function endDrag() { dragging = false; }
    scrub.addEventListener('pointerup', endDrag);
    scrub.addEventListener('pointercancel', endDrag);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (media.classList.contains('product__media--active')) measure();
      }, 150);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (media.classList.contains('product__media--active')) measure();
      });
    }
  })();

  /* "Add to bag" hover: a letter goes invisible, the gap travelling through the
     word — same effect as the header's PLUGINS. Travels the letters only (skips
     the spaces) and stands down while in-cart / processing so it doesn't fight
     the click-scramble. */
  (function () {
    var button = document.querySelector('.product__add');
    if (!button) return;
    var form = button.closest('.product__form');
    var el = button.querySelector('[data-add]');
    if (!el) return;
    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      window.matchMedia('(hover: none)').matches ||
      window.matchMedia('(max-width: 768px)').matches
    ) {
      return;
    }

    var base = 'ADD TO BAG';
    var slots = [];
    for (var k = 0; k < base.length; k++) {
      if (base.charAt(k) !== ' ') slots.push(k);
    }
    var si = 0;
    var timer = null;

    function busy() {
      return form && (form.classList.contains('product__form--in-cart') ||
                      form.classList.contains('product__form--processing'));
    }
    function show() {
      var idx = slots[si];
      el.textContent = base.slice(0, idx) + ' ' + base.slice(idx + 1);
    }
    function step() {
      if (busy()) { stop(); return; }
      si = (si + 1) % slots.length;
      show();
    }
    function start() {
      if (busy()) return;
      clearInterval(timer);
      si = 0;
      show();
      timer = setInterval(step, 150);
    }
    function stop() {
      clearInterval(timer);
      el.textContent = base;
    }

    button.addEventListener('mouseenter', start);
    button.addEventListener('mouseleave', stop);
    button.addEventListener('focus', start);
    button.addEventListener('blur', stop);
  })();


  } catch(e) { console.error(e); }
})();
})();
